import { Component, OnInit,  ElementRef, Inject  } from '@angular/core';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { SiteConfigurationService } from '../../common/site-configuration.service';
import * as myGlobals from '../../global';
import { SafeResourceUrl,
         DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'tn-site-logo',
  templateUrl: '../../themes/default/html/tnsiteheaderlogo.component.html',
  styleUrls: ['../../themes/default/css/tnsiteheader.component.scss'],
  providers: []
})

export class SiteLogo {
  backgroundImg: any;
  _mySettings: any;
  
  constructor(private mySettings: SiteConfigurationService, private sanitizer: DomSanitizer) {
  
    this._mySettings = mySettings.getFullConfig();
    this.backgroundImg = myGlobals.apiBasePath + '/' + this._mySettings.e400.site.logo;
    //this.backgroundImg = '/Uploads/1858625359/1580030173/Shared/logo(2).gif';
    //console.log("Logo: -> " + this.backgroundImg);
    this.backgroundImg = sanitizer.bypassSecurityTrustUrl(this.backgroundImg);    

  }

}



@Component({
  selector: 'tnsiteheader',
  templateUrl: '../../themes/default/html/tnsiteheader.component.html',
  styleUrls: ['../../themes/default/css/tnsiteheader.component.scss']
})
export class TnsiteheaderComponent implements OnInit {
isCollapsed = true;
isCollapsedMenu = true;
isCollapsedSearch = true;

  myMenu = {
    Home: 'Home',
    Ads: 'Immobili',
    AboutUs: 'Chi Siamo',
    Service: 'Servizi',
    News: 'News',
    Privacy: 'Privacy',
    Contact: 'Contatti'
  };

  currentUrl: string;

  public isMenuCollapsed: boolean = true;
  public isNotificationCollapsed: boolean = true;

  constructor(@Inject(Window) private _window: Window, private elementRef:ElementRef, private router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  ngOnInit() {

    this.CreateReference();

  }

  ToggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.isCollapsedSearch = !this.isCollapsedSearch;
 
  }

  public collapsed(event: any): void {

  }

  public expanded(event: any): void {

  }

  CreateReference() {
    let s;
    try {
        s = document.createElement("script");
    } catch (e) {
        return;
    }
    s.id = "Swiperer";
    s.type = "text/javascript";
    s.src="./assets/googletranslate.js";

    let winWidth = this._window.innerWidth;
          
    this.elementRef.nativeElement.appendChild(s);
    
    // this.initdone = true;
    // if (this.initdone) { return; }
  }

}







// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnsiteheader/tnsiteheader.component.ts